import { jsx as e, jsxs as n } from "react/jsx-runtime";
import { useState as g, useCallback as l, useEffect as C } from "react";
import { createPortal as _ } from "react-dom";
import { MakeMeShiny as N } from "../../chat/chat-input/shiny-border.js";
import k from "../../chat/chat-input/send-arrow.svg.js";
import t from "./styles.module.less.js";
function A({
  onSubmit: h,
  onClose: m,
  aiIconSrc: p,
  ga4MeasurementId: r,
  isProduction: u = !0
}) {
  const [o, f] = g(""), [w, y] = g(!1), s = l(
    (i) => {
      if (typeof window < "u" && window.gtag && r) {
        const d = u ? i : `${i}_test`;
        window.gtag("event", d, { send_to: r });
      }
    },
    [r, u]
  );
  C(() => {
    s("atticus_cro_prompt_shown");
  }, [s]);
  const a = l(() => {
    y(!0), setTimeout(m, 200);
  }, [m]), c = l(() => {
    const i = o.trim();
    i && (s("atticus_cro_prompt_engaged"), typeof window < "u" && window.sessionStorage.setItem("from_atticus_cro", "true"), h(i));
  }, [o, h, s]), v = l(
    (i) => {
      i.key === "Enter" && c();
    },
    [c]
  );
  return C(() => {
    const i = (d) => {
      d.key === "Escape" && a();
    };
    return document.addEventListener("keydown", i), () => document.removeEventListener("keydown", i);
  }, [a]), _(
    /* @__PURE__ */ e(
      "div",
      {
        className: `${t.overlay} ${w ? t.closing : ""}`,
        onClick: a,
        children: /* @__PURE__ */ n(
          "div",
          {
            className: `${t.card} ${w ? t.closing : ""}`,
            onClick: (i) => i.stopPropagation(),
            children: [
              /* @__PURE__ */ e(
                "button",
                {
                  className: t.closeButton,
                  onClick: a,
                  "aria-label": "Close",
                  children: /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ e("path", { d: "M19.5 3.75C19.9142 3.75 20.25 4.08579 20.25 4.5C20.25 4.70708 20.1661 4.89456 20.0304 5.03028L13.0607 12L20.0304 18.9696C20.1661 19.1054 20.25 19.2929 20.25 19.5C20.25 19.9142 19.9142 20.25 19.5 20.25C19.2894 20.25 19.099 20.1632 18.9628 20.0233L12.0001 13.0606L5.03039 20.0303C4.89466 20.166 4.70713 20.25 4.5 20.25C4.08579 20.25 3.75 19.9142 3.75 19.5C3.75 19.2912 3.83535 19.1023 3.97308 18.9663L10.9394 12L3.97671 5.03727C3.83685 4.90104 3.75 4.71066 3.75 4.5C3.75 4.08579 4.08579 3.75 4.5 3.75C4.70711 3.75 4.89462 3.83395 5.03034 3.96968L12.0001 10.9393L18.9663 3.97308C19.1023 3.83535 19.2912 3.75 19.5 3.75Z", fill: "#B0B7BD" }) })
                }
              ),
              /* @__PURE__ */ n("div", { className: t.content, children: [
                /* @__PURE__ */ e("div", { className: t.logo, children: /* @__PURE__ */ n("svg", { width: "48", height: "48", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
                  /* @__PURE__ */ n("g", { clipPath: "url(#clip0_ai_chat_prompt)", children: [
                    /* @__PURE__ */ e("path", { d: "M24 48C37.2548 48 48 37.2548 48 24H36C36 30.6274 30.6274 36 24 36C17.3726 36 12 30.6274 12 24C12 17.3726 17.3726 12 24 12V0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z", fill: "#0E5FE3" }),
                    /* @__PURE__ */ e("path", { d: "M40 16C44.4183 16 48 12.4183 48 7.99999C48 3.58173 44.4183 0 40 0C35.5817 0 32 3.58173 32 7.99999C32 12.4183 35.5817 16 40 16Z", fill: "#0E5FE3" })
                  ] }),
                  /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ e("clipPath", { id: "clip0_ai_chat_prompt", children: /* @__PURE__ */ e("rect", { width: "48", height: "48", fill: "white" }) }) })
                ] }) }),
                /* @__PURE__ */ e("h2", { className: t.heading, children: "Not ready to contact a lawyer yet?" }),
                /* @__PURE__ */ e("p", { className: t.subheading, children: "Start by asking your legal question to get free AI answers." }),
                /* @__PURE__ */ e(N, { className: t.shinyWrapper, children: /* @__PURE__ */ n("div", { className: t.inputRow, children: [
                  p && /* @__PURE__ */ e("img", { src: p, className: t.aiIcon, "aria-hidden": "true" }),
                  /* @__PURE__ */ e(
                    "input",
                    {
                      className: t.input,
                      type: "text",
                      placeholder: "Ask your legal question",
                      value: o,
                      onChange: (i) => f(i.target.value),
                      onKeyDown: v,
                      autoFocus: !0
                    }
                  ),
                  /* @__PURE__ */ e(
                    "button",
                    {
                      className: t.sendButton,
                      onClick: c,
                      disabled: !o.trim(),
                      "aria-label": "Send",
                      children: /* @__PURE__ */ e(k, { className: t.sendArrow })
                    }
                  )
                ] }) })
              ] })
            ]
          }
        )
      }
    ),
    document.body
  );
}
export {
  A as AiChatPromptModal
};
